<template>
  <div style="padding: 0;margin: 0;">
    <div style="border-bottom: 1px solid #eee;margin-bottom: 15px;" v-if="hasAlternative">
      <v-layout wrap class="mb-2">
        <v-flex xs7 md9>
          {{ $t('Chatbot answers') }} ({{ $t('pattern') }} {{ currentAlternative + 1 }})
          <i
            class="fas fa-question-circle"
            v-tooltip.top="$t('In case, user wants to random reply messages')"
          ></i>
        </v-flex>
        <v-flex xs5 md3 class="text-xs-right">
          <v-btn
            class="ma-0 extra-small"
            fab
            outline
            small
            color="grey"
            @click="currentAlternative == 0 ? false : (currentAlternative -= 1)"
            :disabled="intentItems.length <= 1 || currentAlternative <= 0"
          >
            <i class="fas fa-chevron-left"></i>
          </v-btn>
          <v-btn
            class="ma-0 extra-small"
            fab
            outline
            small
            color="grey"
            @click="nextAlternative"
            :disabled="intentItems.length >= 5 && currentAlternative >= 4"
          >
            <i class="fas fa-chevron-right"></i>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <v-window v-model="currentAlternative">
      <v-window-item v-for="i in intentItems.length" :key="i">
        <div v-for="(comment, index) in intentItems[i - 1]" :key="'comment_' + i + '_' + index">
          <v-checkbox
            v-model="intentItems[i - 1][index].replyinbox"
            :label="$t('Reply to inbox')"
            color="primary"
            hide-details
            @change="onCheckboxChange"
            style="margin-top: 0;margin-bottom: 5px;"
          ></v-checkbox>
          <!-- reply to inbox -->
          <template v-if="intentItems[i - 1][index].responseinbox">
            <div
              style="width: 20px;min-width: 20px;display: inline-block;float: left;margin-right: 10px;"
            >
              &nbsp;
            </div>
            <template
              v-if="
                intentItems[i - 1][index].responseinbox &&
                  intentItems[i - 1][index].responseinbox.length > 0
              "
            >
              <template v-if="intentItems[i - 1][index].responseinbox[0].type == 'text'">
                <div
                  class="message"
                  style="float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;"
                >
                  <div style="font-size: 12px;color:black">
                    <template>
                      <div style="padding: 8px 6px 2px;background-color:#F1F0F0">
                        <div
                          class="form-control"
                          :class="{
                            'has-error': errors.has(
                              'answer_' + (currentAlternative - 1) + '_text_' + index
                            )
                          }"
                        >
                          <autoresize-textarea
                            maxlength="640"
                            :ref="'answer_' + (currentAlternative - 1) + '_' + index"
                            class
                            :placeholder="$t('Chatbot answers')"
                            v-model="intentItems[i - 1][index].responseinbox[0].text"
                            name="answer"
                            data-vv-as="Answer"
                            :data-vv-name="'answer_' + (currentAlternative - 1) + '_text_' + index"
                            v-validate
                            style="resize: none;display: inherit;margin-bottom: 5px;"
                          ></autoresize-textarea>

                          <span
                            class="text-error"
                            v-show="
                              errors.has('answer_' + (currentAlternative - 1) + '_text_' + index)
                            "
                            >{{
                              errors.first('answer_' + (currentAlternative - 1) + '_text_' + index)
                            }}</span
                          >
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="clearfix"></div>
                </div>

                <intent-prefill
                  @addIntentPrefill="addIntentPrefill(currentAlternative - 1, index, $event)"
                ></intent-prefill>
              </template>
              <template v-if="intentItems[i - 1][index].responseinbox[0].type == 'button'">
                <div
                  class="message"
                  style="float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;"
                >
                  <div style="font-size: 12px;color:black">
                    <template>
                      <div
                        style="padding: 8px 6px 2px;background-color:#F1F0F0;    border-top-left-radius: 10px;    border-top-right-radius: 10px;"
                      >
                        <div
                          class="form-control"
                          :class="{
                            'has-error': errors.has(
                              'answer_' + (currentAlternative - 1) + '_text_' + index
                            )
                          }"
                        >
                          <autoresize-textarea
                            maxlength="640"
                            :ref="'answer_' + (currentAlternative - 1) + '_' + index"
                            class
                            :placeholder="$t('Chatbot answers')"
                            v-model="intentItems[i - 1][index].responseinbox[0].text"
                            name="answer"
                            data-vv-as="Answer"
                            :data-vv-name="'answer_' + (currentAlternative - 1) + '_text_' + index"
                            v-validate
                            style="resize: none;display: inherit;margin-bottom: 5px;"
                          ></autoresize-textarea>

                          <span
                            class="text-error"
                            v-show="
                              errors.has('answer_' + (currentAlternative - 1) + '_text_' + index)
                            "
                            >{{
                              errors.first('answer_' + (currentAlternative - 1) + '_text_' + index)
                            }}</span
                          >
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="clearfix"></div>
                  <div
                    style="float:left;width: 100%;border: 1px solid #eee;border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;"
                  >
                    <ul class="message-group message-group-flush" style="margin-bottom: 0px;">
                      <template
                        v-if="
                          intentItems[i - 1][index].responseinbox[0].buttons &&
                            intentItems[i - 1][index].responseinbox[0].buttons.length > 0
                        "
                      >
                        <li
                          class="message-group-item"
                          style="position:relative;border-left:none;border-right:none;border-bottom:none; border-radius: 0px;text-align: center;padding: 5px 10px"
                          :style="{ 'border-top': bindex != 0 ? '1px solid #eee' : 'none' }"
                          v-for="(button, bindex) in intentItems[i - 1][index].responseinbox[0]
                            .buttons"
                          :key="bindex"
                        >
                          <div style="position: absolute;right: -45px;top: 0px;">
                            <v-btn
                              fab
                              outline
                              color="primary"
                              class="extra-small"
                              @click="deleteButton(index, bindex)"
                            >
                              <i class="fas fa-trash"></i>
                            </v-btn>
                            <!-- <a
                            href="javascript:void(0);"
                            class="btn btn-base-white btn-floating btn-outline-red btn-small"
                            
                            style="margin-left: 5px;"
                          >
                            
                            </a>-->
                          </div>
                          <span style="overflow: auto;position: relative">
                            <add-generic-button
                              v-model="intentItems[i - 1][index].responseinbox[0].buttons[bindex]"
                              @onSave="editButton(index, bindex, $event)"
                              :channel="channel"
                            >
                              <span style="color: #0084FF;" :title="button.title">{{
                                button.title | truncate(12)
                              }}</span>
                              <span class="fas fa-pencil-alt"></span>
                            </add-generic-button>
                            <div class="clearfix"></div>

                            <div style="margin: 0;font-size: 10px;">
                              <span v-if="button.type == 'web_url'" :title="button.url">{{
                                button.url | truncate(20)
                              }}</span>
                              <span v-else-if="button.type == 'postback'" :title="button.payload">{{
                                button.payload | truncate(20)
                              }}</span>
                              <span
                                v-else-if="button.type == 'phone_number'"
                                :title="button.payload"
                                >{{ button.payload | truncate(20) }}</span
                              >
                              <span v-else>&nbsp;</span>
                            </div>
                          </span>
                        </li>
                      </template>
                      <li
                        v-if="
                          intentItems[i - 1][index].responseinbox[0].buttons &&
                            intentItems[i - 1][index].responseinbox[0].buttons.length < 3
                        "
                        class="message-group-item"
                        style="border-left:none;border-right:none;border-bottom:none;border-radius: 0px;text-align: center;padding: 10px 0px"
                        :style="{
                          'border-top':
                            intentItems[i - 1][index].responseinbox[0].buttons.length != 0
                              ? '1px solid #eee'
                              : 'none'
                        }"
                      >
                        <add-generic-button
                          v-model="newButton"
                          @onSave="addNewButton(index, $event)"
                          :channel="channel"
                        >
                          <span class="fas fa-plus"></span>
                          {{ $t('Add button') }}
                        </add-generic-button>
                      </li>
                    </ul>
                  </div>
                  <input
                    type="hidden"
                    v-validate="''"
                    :name="'answer_' + (currentAlternative - 1) + '_buttons_' + index"
                    v-model="intentItems[i - 1][index].responseinbox[0].buttons.length"
                    data-vv-as="Buttons"
                  />
                  <div
                    class="form-control"
                    :class="{
                      'has-error': errors.has(
                        'answer_' + (currentAlternative - 1) + '_buttons_' + index
                      )
                    }"
                  >
                    <span
                      class="text-error"
                      v-show="
                        errors.has('answer_' + (currentAlternative - 1) + '_buttons_' + index)
                      "
                      >{{
                        errors.first('answer_' + (currentAlternative - 1) + '_buttons_' + index)
                      }}</span
                    >
                  </div>
                </div>
                <intent-prefill
                  @addIntentPrefill="addIntentPrefill(currentAlternative - 1, index, $event)"
                ></intent-prefill>
              </template>
              <template v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'image'">
                <div
                  :ref="'answer_' + (currentAlternative - 1) + '_' + index"
                  class="message"
                  style="float:left;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
                >
                  <uploadfile
                    ref="answer"
                    v-model="intentItems[i - 1][index].responseinbox[0].image_url"
                    :height="181"
                    data-vv-as="Image"
                    :data-vv-name="'answer_' + (currentAlternative - 1) + '_image_' + index"
                    v-validate
                  ></uploadfile>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'video'">
                <div
                  :ref="'answer_' + (currentAlternative - 1) + '_' + index"
                  class="message"
                  style="min-height: 150px;border: 1px solid #eee;float:left;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
                >
                  <template v-if="intentItems[i - 1][index].responseinbox[0].picture">
                    <v-img
                      :src="intentItems[i - 1][index].responseinbox[0].picture"
                      :aspect-ratio="16 / 9"
                      color="grey"
                    ></v-img>
                  </template>
                  <template v-else>
                    <v-responsive :aspect-ratio="16 / 9">
                      <div style="background: #eee; height: 100%"></div>
                    </v-responsive>
                  </template>

                  <v-layout
                    fill-height
                    absolute
                    class="text-xs-center"
                    style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                  >
                    <div
                      style="margin: auto; width: 100%"
                      :title="intentItems[i - 1][index].responseinbox[0].source"
                      :alt="intentItems[i - 1][index].responseinbox[0].source"
                    >
                      <v-btn fab small depressed color="white">
                        <v-icon large>play_circle_filled</v-icon>
                      </v-btn>
                    </div>
                  </v-layout>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'generic'">
                <intent-generic-manage
                  v-model="intentItems[i - 1][index].responseinbox[0].data"
                  @deleteMessage="onDelete(index)"
                  :channel="channel"
                ></intent-generic-manage>
              </template>
              <template v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'flex'">
                <intent-line-flex
                  v-model="intentItems[i - 1][index].responseinbox[0].contents"
                  @deleteMessage="onDelete(index)"
                ></intent-line-flex>
              </template>

              <div class="clearfix"></div>
              <div for class="caption mt-3 mb-2">{{ $t('Select reply type') }}</div>
              <div style="overflow-x: auto;">
                <ul class="customize-message-tool">
                  <li
                    @click="selectIntentReplyType('text')"
                    :class="{ active: intentItems[i - 1][index].responseinbox[0].type == 'text' }"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-speech-bubble.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Message') }}
                  </li>
                  <li
                    @click="selectIntentReplyType('button')"
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'button'
                    }"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-button.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Button') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    @click="selectIntentReplyType('image')"
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'image'
                    }"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-image.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Image') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    @click="selectIntentReplyType('generic')"
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'generic'
                    }"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Menu list') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    @click="selectIntentReplyType('video')"
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'video'
                    }"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-video.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Video') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </template>
          <div class="clearfix"></div>

          <div class="hr"></div>
          <v-checkbox
            v-model="intentItems[i - 1][index].replycomment"
            :label="$t('Reply to comment')"
            color="primary"
            hide-details
            @change="onReplyComment(i - 1, index, $event)"
            style="margin-top: 0;margin-bottom: 5px;"
          ></v-checkbox>
          <template v-if="intentItems[i - 1][index].replycomment">
            <template
              v-if="
                intentItems[i - 1][index].responsecomment &&
                  intentItems[i - 1][index].responsecomment.length > 0
              "
            >
              <div
                style="width: 20px;min-width: 20px;display: inline-block;float: left;margin-right: 10px;"
              >
                &nbsp;
              </div>
              <div
                class="message"
                style="margin-bottom: 10px;float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;"
              >
                <div style="font-size: 12px;color:black">
                  <template>
                    <div style="padding: 5px 8px 6px;background-color:#F1F0F0">
                      <div
                        class="form-control"
                        :class="{ 'has-error': errors.has('answer_reply_comment') }"
                      >
                        <autoresize-textarea
                          :ref="'replyComment'"
                          class="form-control"
                          placeholder="Answer"
                          v-model="intentItems[i - 1][index].responsecomment[0].text"
                          name="answer"
                          data-vv-as="Answer"
                          :data-vv-name="'answer_reply_comment'"
                          v-validate="''"
                          style="resize: none"
                          maxlength="640"
                        ></autoresize-textarea>
                        <!-- <textarea ref="answer" class="form-control" placeholder="Answer" @keyup="resizeTextarea(index)" v-model="intentItems[i-1][index].responseinbox[0].value"  name="answer" data-vv-as="Answer" v-validate="'required'" style="resize: none" @keydown="onTyping"></textarea> -->
                        <span class="text-error" v-show="errors.has('answer_reply_comment')">{{
                          errors.first('answer_reply_comment')
                        }}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="clearfix"></div>
              <template
                v-if="
                  intentItems[i - 1][index].responsecomment[0].image_url ||
                    intentItems[i - 1][index].responsecomment[0].image_url == ''
                "
              >
                <div
                  style="width: 20px;min-width: 20px;display: inline-block;float: left;margin-right: 10px;"
                >
                  <a
                    href="javascript:void(0);"
                    @click="deleteImage(i - 1, index)"
                    style="float:left; margin-left: 5px;"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </div>
                <div
                  :ref="'answer_' + i"
                  class="message"
                  style="float:left;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
                >
                  <uploadfile
                    ref="answer"
                    v-model="intentItems[i - 1][index].responsecomment[0].image_url"
                    :height="181"
                    data-vv-as="Image"
                    :data-vv-name="'replycomment_' + i + '_image_' + index"
                    v-validate
                  ></uploadfile>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-else>
                <div>
                  <label for>{{ $t('Add more item') }}</label>
                  <ul class="customize-message-tool">
                    <li @click="addImage(i - 1, index)">
                      <vue-simple-svg
                        :filepath="'/static/img/assets/get_started/add-image.svg'"
                        width="40px"
                        height="40px"
                        class="img"
                      />
                      {{ $t('Image') }}
                    </li>
                  </ul>
                </div>
              </template>
            </template>
          </template>

          <div class="clearfix"></div>
          <div class="hr" style="margin-top: 10px;"></div>
          <v-checkbox
            v-model="intentItems[i - 1][index].hidecomment"
            :label="$t('Hide comment')"
            color="primary"
            hide-details
            style="margin-top: 0;margin-bottom: 5px;"
            @change="onHideComment(i - 1, index, $event)"
          ></v-checkbox>
        </div>
      </v-window-item>
    </v-window>

    <v-dialog v-model="showLineFlex" width="1000">
      <v-card>
        <v-layout>
          <v-flex>
            <div class="primary--text headline pa-2">Line Flex Message</div>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="cancelAddFlexMessage">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-card-text v-if="flexMessage">
          <intent-line-flex-message v-model="flexMessage.contents"></intent-line-flex-message>
        </v-card-text>

        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="cancelAddFlexMessage">{{ $t('Cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="saveAddFlexMessage">{{ $t('Save') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <modal-video v-model="showVideo" @onAddVideo="addVideo"></modal-video>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import uploadfile from '@/components/elements/uploadfile'
import ModalVideo from './ModalVideo'
import IntentLineFlexMessage from './IntentLineFlexMessage'
import IntentLineFlex from './IntentLineFlex'
import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import IntentGenericManage from './IntentGenericManage'
import IntentPrefill from './IntentPrefill'
export default {
  props: {
    value: {
      default: ''
    },
    hasAlternative: {
      default: true,
      type: Boolean
    },
    channel: {
      default: 'all'
    }
  },
  components: {
    AutoresizeTextarea,
    uploadfile,
    ModalVideo,
    IntentLineFlexMessage,
    IntentLineFlex,
    AddGenericButton,
    IntentGenericManage,
    IntentPrefill
  },
  data: function() {
    return {
      currentReplyInboxType: 'text',
      group: '',
      intentItems: [],
      currentAlternative: 0,
      newComment: {
        type: 'responsepost',
        replyinbox: true,
        replycomment: false,
        hidecomment: false,
        responseinbox: [
          {
            type: 'text',
            text: ''
          }
        ],
        responsecomment: [
          {
            type: 'text',
            text: ''
          }
        ]
      },

      showVideo: false,
      showLineFlex: false,
      flexMessage: undefined,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      welcomeMessage: 'welcomeMessage'
    })
  },
  created: function() {
    var vm = this
    vm.group = vm.value
    vm.intentItems = vm.group
    if (vm.intentItems[0].length === 0) {
      vm.intentItems[0][0] = vm.newComment
    }
    this.resetFlexMessage()
  },
  methods: {
    addNewButton: function(index, payload) {
      var vm = this
      if (vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
        // this.$emit('input', this.bubbleMessages)
      }
    },
    editButton: function(index, bindex, payload) {
      var vm = this
      if (vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons[bindex]) {
        // this.intentItems[index].value.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(
          vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons,
          bindex,
          payload
        )
        // this.$emit('input', this.bubbleMessages)
      }
    },
    deleteButton: function(index, bindex) {
      var vm = this
      vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons.splice(bindex, 1)
      // this.$emit('input', this.bubbleMessages)
    },
    addIntentPrefill: function(index, subindex, prefill) {
      var vm = this
      let cursorPosition = this.$refs['answer_' + index + '_' + subindex][0].$el.selectionStart

      if (vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].type === 'text') {
        vm.$set(
          vm.intentItems[vm.currentAlternative][0].responseinbox[subindex],
          'text',
          [
            vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].text.slice(
              0,
              cursorPosition
            ),
            '{' + prefill + '}',
            vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].text.slice(
              cursorPosition
            )
          ].join('')
        )
      } else if (
        vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].type == 'button'
      ) {
        vm.$set(
          vm.intentItems[vm.currentAlternative][0].responseinbox[subindex],
          'text',
          [
            vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].text.slice(
              0,
              cursorPosition
            ),
            '{' + prefill + '}',
            vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].text.slice(
              cursorPosition
            )
          ].join('')
        )
      }
      // this.$emit('input', this.bubbleMessages)
    },
    cancelAddFlexMessage: function() {
      this.showLineFlex = false
      this.resetFlexMessage()
    },
    saveAddFlexMessage: function() {
      var vm = this
      vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, vm.flexMessage)

      // vm.$emit('input', vm.bubbleMessages)
      vm.showLineFlex = false
      vm.resetFlexMessage()
    },
    resetFlexMessage: function() {
      this.flexMessage = {
        type: 'flex',
        altText: 'You received a message',
        contents: '{}'
      }
    },
    addVideo: function(video) {
      var vm = this
      vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, video)
      // vm.$emit('input', vm.bubbleMessages)
      vm.showVideo = false
    },
    selectIntentReplyType: function(type) {
      var vm = this

      if (type == 'text') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          text: '',
          type: type
        })
      } else if (type == 'button' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          text: '',
          buttons: [],
          type: type
        })
      } else if (type == 'image' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          image_url: '',
          type: type
        })
      } else if (type == 'generic' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          data: [
            {
              image_url: null,
              title: '',
              subtitle: '',
              buttons: []
            }
          ],
          type: type
        })
      } else if (type == 'welcome_message' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          type: type
        })
      } else if (type == 'viewsummary' && vm.$store.getters.getPackage == 'premium') {
        if (vm.products.length == 0) {
          return false
        }
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          type: 'text',
          text: '{viewsummary}'
        })
      } else if (type == 'video' && vm.$store.getters.getPackage == 'premium') {
        vm.showVideo = true
      } else if (type == 'line_flex' && vm.$store.getters.getPackage == 'premium') {
        vm.showLineFlex = true
      }
      // vm.$emit('input', vm.bubbleMessages)
    },
    addImage: function(index, subindex) {
      this.$set(this.intentItems[index][subindex].responsecomment[0], 'image_url', '')
    },
    deleteImage: function(index, subindex) {
      this.$delete(this.intentItems[index][subindex].responsecomment[0], 'image_url')
    },
    nextAlternative: function() {
      if (this.currentAlternative + 1 === this.intentItems.length) {
        var comment = JSON.parse(JSON.stringify(this.newComment))
        // this.intentItems.push([])
        this.intentItems.push([])
        this.intentItems[this.currentAlternative + 1][0] = comment
      }
      this.currentAlternative += 1
    },
    onCheckboxChange: function() {
      this.$forceUpdate()
    },
    onHideComment: function(index, subindex, value) {
      this.onCheckboxChange()
    },
    onReplyComment: function(index, subindex, value) {
      this.onCheckboxChange()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentComment.vue